import { MealTime } from "@/clients/models/MealTime";
import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { useLifeStyle } from "@/features/lifestyle/hooks/use-lifestyle";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import LifestyleSelectionList from "../../components/lifestyle-selection-list";

export default function OnboardingBreakfast() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  const {
    selectedPreference,
    handlePreferenceSelect,
    handleSubmit,
    isUpdating,
    options,
    isLoading,
  } = useLifeStyle(MealTime.BREAKFAST, () => {
    navigation.push(info?.nextPath ?? "", "none");
  });

  return (
    <ProfilePageContainer>
      <PageTitleComponent
        title="Tell us about your breakfast"
        description="We'll tailor your companion around the places you already go."
        className="mt-2 mb-6 w-full"
      />

      <LifestyleSelectionList
        isLoading={isLoading}
        options={options?.lifestyleOptionsData ?? []}
        selectedPreference={selectedPreference}
        handlePreferenceSelect={handlePreferenceSelect}
      />

      <StepsButtons
        previousPath={info?.previousPath}
        disabled={isUpdating}
        type="button"
        onClick={handleSubmit}
      />
    </ProfilePageContainer>
  );
}
